import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import _ from "lodash";

import { Input } from "../../../components/input/Input";
import { Mobile } from "../../../hocs/Responsive";
import { Button } from "../../../components/button/Button";
import { Icon } from "../../../components/icon/Icon";

import { getEulaHeaderHeight } from "../../../store/layout";

import "./HelpSearch.scss";

const MOBILE_HEADER_HEIGHT = 40;

const HelpSearchContent = ({
  onGoToNext,
  onGoToPrevious,
  hasNoMatches,
  value,
  onChange,
  onDoSearch,
  intl,
}) => {
  const eulaHeaderHeight = useSelector(getEulaHeaderHeight);

  const [isSearchApplied, setSearchApplied] = useState(false);

  const emitValue = _.debounce((searchValue) => {
    const isInputLongEnough = searchValue.length > 2;

    setSearchApplied(isInputLongEnough);
    onDoSearch(isInputLongEnough ? searchValue : "");
  }, 300);

  const handleInputChange = (searchValue) => {
    emitValue(searchValue);
    onChange(searchValue);
  };

  const noResults = isSearchApplied && hasNoMatches;
  const noResultStatusId = "noResultStatus";

  return (
    <div
      className="help-search"
      style={{ top: `${eulaHeaderHeight + MOBILE_HEADER_HEIGHT}px` }}
    >
      <Mobile>
        <h1 className="help-search__subtitle">
          <FormattedMessage id="help_and_documentation" />
        </h1>
      </Mobile>
      <div className="help-search__controls">
        <Input
          icon="fa-solid fa-search"
          className="help-search__input"
          placeholder={intl.formatMessage({ id: "search" })}
          onChange={(e) => handleInputChange(e.target.value)}
          onClear={() => handleInputChange("")}
          value={value}
          aria-label={intl.formatMessage({
            id: "aria_help_and_documentation",
          })}
          {...(noResults && {
            "aria-describedby": noResultStatusId,
          })}
        />
        {isSearchApplied && !hasNoMatches && (
          <Mobile>
            <Button
              className="help-search__nav-button"
              onClick={onGoToPrevious}
              color={"secondary"}
              size={"large"}
            >
              <Icon icon="fa-regular fa-chevron-up" />
            </Button>
            <Button
              className="help-search__nav-button"
              onClick={onGoToNext}
              color={"secondary"}
              size={"large"}
            >
              <Icon icon="fa-regular fa-chevron-down" />
            </Button>
          </Mobile>
        )}
      </div>
      {noResults && (
        <div
          className="help-search__message"
          id={noResultStatusId}
          role="status"
        >
          <Icon icon="fa-regular fa-triangle-exclamation" />
          <FormattedMessage id="no_matches_found" />
        </div>
      )}
    </div>
  );
};

export const HelpSearch = injectIntl(HelpSearchContent);
